import React from 'react';
import { BaseTooltipPluginView, } from '../BaseTooltip';
import { TooltipButton } from './TooltipButton';
export class TooltipButtonPluginView extends BaseTooltipPluginView {
    constructor(view, options) {
        super(view, options);
        this.forceEdit = false;
        this.toggleEdit = () => {
            this.forceEdit = !this.forceEdit;
            this.render();
        };
        this.onViewFocus = () => {
            this.forceEdit = false;
            this.manualHidden = false;
            this.render();
        };
        this.enableHideOnBlur = options.disableHideOnBlur !== true;
        this.buttonContent = options.buttonContent;
        this.formContent = options.formContent;
        if (this.enableHideOnBlur) {
            this.view.dom.addEventListener('focus', this.onViewFocus);
        }
    }
    destroy() {
        super.destroy();
        this.view.dom.removeEventListener('focus', this.onViewFocus);
    }
    renderContent(currentNode) {
        return (React.createElement(React.Fragment, null, this.forceEdit && this.formContent ? (React.createElement("div", null, this.formContent(this.view, currentNode, this.changeAttrsCb))) : (React.createElement(TooltipButton, { domRef: currentNode.dom, onOutsideClick: this.onOutsideClick }, this.buttonContent(this.view, currentNode, this.toggleEdit)))));
    }
    setCurrentNode(node) {
        var _a, _b;
        super.setCurrentNode(node);
        (_b = (_a = this.currentNode) === null || _a === void 0 ? void 0 : _a.dom) === null || _b === void 0 ? void 0 : _b.addEventListener('dblclick', this.toggleEdit);
    }
    updateTooltipView() {
        var _a, _b;
        (_b = (_a = this.currentNode) === null || _a === void 0 ? void 0 : _a.dom) === null || _b === void 0 ? void 0 : _b.removeEventListener('dblclick', this.toggleEdit);
        super.updateTooltipView();
    }
}
